<template>
  <div v-if="channel">
    <section class="section">
      <div class="container">
        <ui-section-header>
          <template v-slot:title>Active price types</template>
        </ui-section-header>

        <table class="table is-fullwidth is-striped">
          <tbody>
            <tr v-for="pricetype in channel.PriceTypes" :key="pricetype.id">
              <td>{{ getPriceTypeName(pricetype.PriceType) }}</td>
              <td width="100" class="has-text-right">
                <div class="field is-grouped">
                  <p class="control">
                    <a @click="deletePricetype(pricetype)">
                      <span class="icon is-small has-text-danger">
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </span>
                    </a>
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <ui-section-header>
          <template v-slot:title>Available price types</template>
        </ui-section-header>

        <table class="table is-fullwidth is-striped">
          <tbody>
            <tr v-for="pricetype in unselectedPricetypes" :key="pricetype.id">
              <td>{{ pricetype.name }}</td>
              <td width="100" class="has-text-right">
                <div class="field is-grouped">
                  <p class="control">
                    <a @click="addPricetype(pricetype)">
                      <span class="icon is-small">
                        <font-awesome-icon :icon="['fas', 'plus']" />
                      </span>
                    </a>
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import channelProvider from '@/providers/channel'

export default {
  components: {},

  props: {},

  data() {
    return {
      channelId: Number(this.$route.params.channelId),
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      pricetypes: [],
    }
  },

  computed: {
    ...mapState('channelStore', ['channel']),

    unselectedPricetypes() {
      let self = this
      let pricetypes = []

      if (self.channel && self.pricetypes) {
        for (let i = 0; i < self.pricetypes.length; i++) {
          let pricetype = self.pricetypes[i]
          let index = -1
          if (self.channel.PriceTypes.length > 0) {
            index = self.channel.PriceTypes.findIndex(
              (pt) => pt.PriceType === pricetype.id
            )
          }

          if (index === -1) {
            pricetypes.push(pricetype)
          }
        }
      }

      return pricetypes
    },
  },

  created() {
    this.pricetypes.push({ id: 'PerHourPerSeat', name: 'Per Hour per seat' })
    this.pricetypes.push({ id: 'PerDayPartOnly', name: 'Per day part' })
    this.pricetypes.push({
      id: 'PerDayPartPerPerson',
      name: 'Per day part per person',
    })
  },

  methods: {
    ...mapMutations('channelStore', ['setChannel']),

    isSelected(priceType) {
      return (
        this.channel.PriceTypes.findIndex((c) => c.PriceType === priceType) > -1
      )
    },

    getPriceTypeName(pricetype) {
      return this.pricetypes.find((p) => p.id === pricetype).name
    },

    addPricetype(pricetype) {
      this.channel.PriceTypes.push({
        ChannelId: this.channel.Id,
        PriceType: pricetype.id,
      })
      this.setChannel(this.channel)

      this.saveChannelPricetypes()
    },

    deletePricetype(pricetype) {
      let index = this.channel.PriceTypes.findIndex(
        (pt) => pt.PriceType === pricetype.PriceType
      )

      if (index > -1) {
        this.channel.PriceTypes.splice(index, 1)
        this.setChannel(this.channel)

        this.saveChannelPricetypes()
      }
    },

    saveChannelPricetypes() {
      let self = this

      let pricestypes = this.channel.PriceTypes.map((pt) => pt.PriceType)

      channelProvider.methods
        .updateChannelPricetypes(this.channel.Id, pricestypes)
        .then((response) => {
          if (response.status === 200) {
            self.setChannel(response.data)
          }
        })
        .finally(() => {})
    },
  },
}
</script>
